import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  section: 'data-section-type="main-search"',
  resultPages: 'data-pages',
  resultArticles: 'data-articles',
}
const qsAll = {
  pages: 'data-page-card',
  articles: 'data-article-card',
}

export const setupSearch = () => {
  cacheDom(dom, qs, qsAll)
  if(dom.section) {
    if(dom.resultPages) dom.pages.forEach(page => dom.resultPages.appendChild(page.closest('li')))
    if(dom.resultArticles) dom.articles.forEach(article => dom.resultArticles.appendChild(article.closest('li')))
  }
}